import type {
  FlowRunStatus,
  FlowRunSummaryDto,
  FlowStatus,
} from '@reelplicate/api-client/model';

/** How a flow's status reads on a Badge, on the index and in the editor. */
export const STATUS_BADGE: Record<
  FlowStatus,
  { label: string; tone: 'neutral' | 'success' | 'warning' }
> = {
  DRAFT: { label: 'Draft', tone: 'neutral' },
  ACTIVE: { label: 'Active', tone: 'success' },
  PAUSED: { label: 'Paused', tone: 'warning' },
};

/** How a run's status reads on a Badge, on the Runs and Running pages. */
export const RUN_STATUS: Record<
  FlowRunStatus,
  { label: string; tone: 'neutral' | 'info' | 'success' | 'warning' | 'danger' }
> = {
  QUEUED: { label: 'Queued', tone: 'info' },
  RUNNING: { label: 'Running', tone: 'info' },
  WAITING: { label: 'Waiting for review', tone: 'warning' },
  SLEEPING: { label: 'Measuring', tone: 'info' },
  SUCCEEDED: { label: 'Done', tone: 'success' },
  FAILED: { label: 'Failed', tone: 'danger' },
  CANCELLED: { label: 'Stopped', tone: 'neutral' },
};

/** What started a run, as its label begins: "Test run", "Scheduled run", "Next round" (a winner's loop). */
export function runKind(run: Pick<FlowRunSummaryDto, 'mode' | 'trigger'>): string {
  if (run.mode === 'TEST') return 'Test run';
  if (run.trigger === 'SCHEDULE') return 'Scheduled run';
  if (run.trigger === 'WINNER') return 'Next round';
  return 'Run';
}
